export const fr_CA = {
  // Header/Sidebar
  user: "Utilisateur",
  users: "Utilisateurs",
  installations: "Installations",
  settings: "Paramètres",
  certificate: "Certificat",
  main_settings: "Paramètres principaux",
  terminology: "Termeinologie",
  equipment: "Équipement",
  security: "Sécurité",
  tenants: "Locataires",
  collapse: "Réduire",
  branding: "Image de marque",
  sign_out: "Se déconnecter",
  hello: "Bonjour!",
  reports: "Rapports",

  // Misc
  save: "Sauvegarder",
  cancel: "Annuler",

  // Installation Table
  status: "État",
  clear: "Effacer",
  date: "Date",
  technician: "Technicien",
  customer_phone: "Téléphone du client",
  address: "Adresse",
  unit: "Unité",
  city: "Ville",
  state_prov: "État/Prov",
  rooms_tested: "Pièces testées",
  tested: "Testé",
  plan: "Abonnement",
  rows_per_page: "Lignes par page:",
  recommended_short: "Recom.",
  notes: "Notes",

  // Certificate Branding Tab
  current_image: "Image actuelle: ",
  using_default_logo: "Utilisation du logo par défaut",
  new_image: "Nouvelle image",
  branding_loading_error:
    "Erreur de chargement de la marque. Veuillez réessayer plus tard.",
  upload_new_image: "Télécharger une nouvelle image",
  clear_custom_image: "Supprimer l'image personnalisée",
  clear_custom_color: "Supprimer la couleur personnalisée",
  brand_color: "Couleur de la marque",
  header_message: "Message d'en-tête",
  header_education_message: "Message d'éducation en en-tête",
  footer_education_message: "Message d'éducation en pied de page",
  preview: "Aperçu",
  file_must_be_less_than_size_limit: "Le fichier doit être inférieur à 30KB",

  // Certificate Headers
  congrats_message:
    "Votre installation WiFi est terminée et a été certifiée par RouteThis!",
  installation_details: "Détails de l'installation",
  wireless_speed_test: "Test de vitesse sans fil",
  wireless_speed_test_hidespeedtest: "Test de vitesse de l'internet wi-fi",
  wireless_performance: "Performance sans fil",
  photos: "Photos",
  signal_maps: "Cartes de signal",
  wifi_information: "Comprendre la vitesse de votre wi-fi",

  // Certificate Chambre Noms
  singular_room: "Room",
  room_type_bathroom: "Salle de bain",
  room_type_bedroom: "Chambre à coucher",
  room_type_dining_room: "Salle à manger",
  room_type_entry_or_hall: "Entrée/Hall",
  room_type_garage: "Garage",
  room_type_kitchen: "Cuisine",
  room_type_living_room: "Salon",
  room_type_office: "Bureau",
  room_type_other: "Autre",

  // Pod Name
  pod_1: "Pod de maillage",
  pod_2: "Point d'accès",
  pod_3: "Nœud de maillage",
  pod_4: "Puck de maillage",
  pod_5: "Balise",
  pod_6: "Amplificateur wi-fi",
  pods_1: "Pods de maillage",
  pods_2: "Points d'accès",
  pods_3: "Nœuds Mesh",
  pods_4: "Pucks Mesh",
  pods_5: "Balises",
  pods_6: "Amplificateurs wi-fi",

  // Routeur Name
  router_1: "Routeur",
  router_2: "Modem",
  router_3: "Passerelle",
  router_4: "Concentrateur",
  router_5: "Passerelle résidentielle",

  // Niveau Name
  level_1: "Niveau",
  level_2: "Étage",
  levels_1: "Niveaux",
  levels_2: "Étages",

  // a11y Labels
  go_to_homepage: "Touser à la page d'accueil",
  edit_user_x: "Modifier l'utilisateur [X]",
  open_certificate_for_addr: "Ouvrir le certificat pour [ADDR]",
  clear_all_filters: "effacer tous les filtres",
  expand_sidebar: "Élargir la barre latérale",
  current_tenant_branding_image: "Image de marque actuelle du locataire",
  new_tenant_branding_image: "Nouvelle image de marque du locataire",

  // Certificate Pod Info
  recommended: "Recommandé(s)",
  installed: "Installé(s)",
  installed_singular: "Installé",
  total: "Total",

  // Certificate Signal Table
  front_building: "Façade du bâtiment",
  speed: "Vitesse",
  video: "Vidéo",
  rssi: "RSSI",
  rssi_description: "dBm",
  link: "Lien",
  frequency_short: "Freq.",
  frequency_description: "MHz",
  channel_short: "Ch.",

  // Certificate Légende
  legend: "Legend",
  measured_speed: "Vitesse Mesurée",
  measured_speed_description: "Mbps",
  plan_speed: "Vitesse de l'abonnement",

  // Certificate Speedtest Result
  speedtest_passed:
    "La vitesse est dans la plage attendue pour la plupart des appareils mobiles. Tous les appareils sans fil ne sont pas capables d'atteindre la vitesse maximale du de l'abonnement. Voir ci-dessous pour les tests individuels de la pièce.",
  speedtest_passed_hidespeedtest:
    "Vitesse de connexion Internet vérifiée pour votre forfait.",
  speedtest_failed:
    "Testé sur un téléphone ou une tablette. Tous les appareils sans fil ne sont pas capables d'atteindre la vitesse maximale du de l'abonnement. Voir ci-dessous pour les tests individuels de la pièce.",
  speedtest_24ghz:
    "Le test de vitesse a été effectué sur la bande de 2,4 GHz ; vitesse lente enregistrée.",
  speedtestmessages_strong:
    "La vitesse est dans la plage prévue pour la plupart des appareils mobiles.",
  speedtestmessages_weak:
    "La vitesse est bien inférieure à la plage prévue pour la plupart des appareils mobiles.",
  speedtestmessages_medium:
    "La vitesse est inférieure à la plage prévue pour la plupart des appareils mobiles.",
  wifi_activities_highspeed_videos: "Plusieurs vidéos 4K",
  wifi_activities_highspeed_conferencing: "Vidéo-conférence",
  wifi_activities_highspeed_gaming: "Jeu en ligne",
  wifi_activities_highspeed_music: "Diffusion de musique",
  wifi_activities_lowspeed_email: "Courriel et réseaux sociaux",
  speedTestIndicatorText_weak: "Vitesse wi-fi faible",
  speedTestIndicatorText_medium: "Vitesse wi-fi plus lente",
  speedTestIndicatorText_strong: "Vitesse wi-fi optimale",
  signal_coverage: "Couverture du signal",
  signaltablemessage_title:
  "Les activités sont classées de gauche à droite en fonction de la force du signal requise.",
  signaltablemessage_subtitle:
  "Si vous pouvez effectuer une activité dans la pièce indiquée, vous pouvez également effectuer toutes les activités à sa droite.",
  alerts: "Alertes",
  alertMessages_noAlert: "Aucune alerte à cet étage",
  alertmessages_lowPodsAlert:
    "Tous les amplificateurs wi-fi recommandés n'ayant pas été installés, vous pourriez constater une diminution de la vitesse à mesure que vous vous éloignez du routeur.",
  alertMessages_bandAlert:
  "Le test de vitesse a été effectué sur la bande de 2,4 GHz ; vitesse lente enregistrée.",
  alertMessages_lowSignalAlert:
  "Votre connexion ici sera stable et vous permettra de consulter e-mails et réseaux sociaux, mais vous ne bénéficierez pas des vitesses disponibles dans d'autres parties de votre domicile.",
  alertMessages_veryLowSignalAlert:
  "Votre signal est très faible. Vous pourriez constater des temps de chargement longs et des interruptions. Pour une meilleure expérience, déplacez-vous vers une zone où le signal est plus fort.",
  customLowPodsAlertString:
  "Étant donné que tous les %PODSNAME recommandés n'ont pas été installés, vous pourriez constater une diminution de la vitesse en vous éloignant du %ROUTERNAME.",


  
  
  
    // Reports Page
  reports_access_error:
    "Veuillez contacter votre administrateur pour voir cette page",

  // Login/Reset Mot de passe
  password: "Password",
  sign_in: "Se connecter",
  forgot_password: "Mot de passe oublié",
  reset_password: "Réinitialiser le mot de passe",
  reset_password_instructions:
    "Pour réinitialiser votre mot de passe, entrez votre adresse email ci-dessus et nous enverrons des instructions, si le compte existe.",
  sent_reset_password_code:
    "Nous avons envoyé un code de réinitialisation de mot de passe à [email] Entrez ce code et un nouveau mot de passe.",
  reset_code: "Code de réinitialisation",
  new_password: "Nouveau mot de passe",
  reenter_new_password: "Re-entrez le nouveau mot de passe",
  must_include_email: "Doit inclure un courriel",
  old_password: "Ancien mot de passe",
  set_new_password: "Définir un nouveau mot de passe",
  password_expired: "Mot de passe expiré",
  toggle_password_visibility: "Basculer la visibilité du mot de passe",
  change_your_password: "Changez votre mot de passe",
  change_password: "Changer le mot de passe",
  set_password: "Définir le mot de passe",

  // Users List
  new_user: "Nouvel utilisateur",
  edit_user: "Modifier l'utilisateur",
  bulk_import: "Importeration en vrac",
  bulk_import_users: "Importation en vrac des utilisateurs",
  show_disabled_users: "Afficher les utilisateurs désactivés",
  name: "Name",
  role: "Rôle",
  roles: "Rôles",
  location: "Emplacement",
  group: "Groupe",
  manager: "Gestionnaire",
  download_bulk_template: "Télécharger le modèle en vrac",
  user_id_email: "Identifiant de l'utilisateur (courriel)",

  // Valid User roles
  user_role: "user",
  tenant_admin_role: "AdminLocataire",
  super_admin_role: "SuperAdmin",
  tenant_admin: "Admin du Locataire",
  super_admin: "Super Admin",

  // Créer/Modifier User Modal
  email_required: "Courriel (Requis)",
  first_name: "Prénom",
  last_name: "Nom de famille",
  force_password_reset: "Forcer la réinitialisation du mot de passe",
  resend_validation_code: "Renvoyer le code de validation",
  enable_user: "Actifr l'utilisateur",
  disable_user: "Désactiver l'utilisateur",
  certify: "Certifier",
  unverified: "Non vérifié",
  locked_out: "Verrouillé",
  disabled: "Désactivé",
  reset_user_password_confirmation:
    "Êtes-vous sûr de vouloir réinitialiser le mot de passe de cet utilisateur ?",
  resend_validation_code_confirmation:
    "Êtes-vous sûr de vouloir renvoyer le code de validation ?",
  cannot_disable_yourself: "Vous ne pouvez pas vous désactiver vous-même",
  cancel_changes: "Annuler les modifications",

  // Snackbar Messages
  snackbar_disable_success: "Utilisateur désactivé avec succès :",
  snackbar_disable_error: "Erreur lors de la désactivation de l'utilisateur :",
  snackbar_enable_success: "Utilisateur activé avec succès :",
  snackbar_enable_error: "Erreur lors de l'activation de l'utilisateur :",
  snackbar_password_reset_success:
    "Réinitialisation de mot de passe pour l'utilisateur réussie :",
  snackbar_password_reset_error:
    "Erreur lors de la réinitialisation du mot de passe de l'utilisateur :",

  // Bulk Import Modal
  csv_format_requirements:
    "Votre fichier CSV doit être correctement formaté. Si vous n'êtes pas sûr du format, vous pouvez aussi",
  csv_format_download_link: "télécharger un modèle de fichier ici.",

  csv_format_error:
    "Nous n'avons pas pu traiter votre fichier téléchargé, veuillez vous assurer que votre fichier est dans le format correct et comprend les en-têtes 'email' et 'manager_0'.",
  select_csv: "Parcourir le fichier CSV",
  import: "Import",
  file_too_large: "Fichier trop grand (Maximum de IMPORT_LIMIT utilisateurs)",
  required_headers_missing: "En-têtes requis manquants : email",
  user_import_starting:
    "L'importation des utilisateurs commence. Vous recevrez un courriel de résumé d'importation dans quelques minutes.",
  change_file: "Changer de fichier",

  // Bulk Import Messaging
  bulk_processing_1: "Nous traitons le fichier :",
  bulk_processing_2:
    "Dès que nous aurons terminé, nous vous enverrons un courriel avec tous les détails.",
  bulk_complete_1: "Terminé :",
  bulk_complete_2: "est maintenant téléchargé.",
  bulk_error:
    "Une erreur est survenue et votre fichier n'a pas été téléchargé sur le serveur. Veuillez vérifier votre courrier électronique pour plus de détails.",
  bulk_thanks_header: "Merci d'avoir téléchargé votre fichier !",
  bulk_thanks_content:
    "Nous travaillons actuellement à son traitement, et dès que nous aurons terminé, nous vous enverrons un courrier électronique avec tous les détails. Vous pouvez également garder un œil sur l'application pour des mises à jour sur le statut de votre fichier.",

  // Tenant Main Settings
  email_language: "Langue de courrier électronique",
  country: "Pays",
  description_optional: "Description (Facultatif)",
  units_feet_meters: "Unités (Pieds, Mètres)",
  certify_id: "Certifier l'ID",
  resolve_id: "Résoudre l'ID",
  sms_settings: "Paramètres SMS",
  udp_flood_settings: "Paramètres de l'inondation UDP",
  udp_flood_settings_absolute_ideal:
    "PASS Si la vitesse de l'inondation UDP est supérieure à (Mbps)",
  udp_flood_settings_absolute_minimum:
    "AVERTISSEMENT Si la vitesse de l'inondation UDP est supérieure à (Mbps)",
  udp_flood_settings_plan_multiple:
    "PASS Si la vitesse de l'inondation UDP est supérieure à (fois la vitesse prévue/vitesse maximale)",
  udp_flood_settings_absolute_plan_percentage:
    "AVERTISSEMENT Si la vitesse de l'inondation UDP est supérieure à (% de la vitesse prévue/vitesse maximale)",
  sms_from: "SMS de",
  sms_body: "Corps du SMS",
  default_sms_body:
    "Votre installation WiFi est terminée et a été certifiée par [NAME]! \n Voir votre certificat ici: [LINK]",
  sms_body_helper_text:
    "Certify enverra ce message au client. [LINK] sera remplacé par un lien vers le certificat (obligatoire). [NAME] sera remplacé par le contenu du champ Nom (facultatif)",
  link_must_be_in_sms_body: "[LINK] doit être dans le corps du SMS.",
  update_successful: "Mise à jour réussie",
  creation_successful: "Création réussie",

  // Tenant Terminology Settings
  term: "Term",
  example_usage: "Exemple d'utilisation",
  customer_example_usage_1:
    "En consultation avec le client, confirmez le bâtiment sélectionné, ou revenez pour modifier l'adresse.",
  customer_example_usage_2:
    "En consultation avec l'abonné, confirmez le bâtiment sélectionné, ou revenez pour modifier l'adresse.",
  router_example_usage_1:
    "Tapez sur l'emplacement du routeur proposé ci-dessous.",
  router_example_usage_2:
    "Tapez sur l'emplacement du modem proposé ci-dessous.",
  router_example_usage_3:
    "Tapez sur l'emplacement de la passerelle proposée ci-dessous.",
  router_example_usage_4:
    "Tapez sur l'emplacement du concentrateur proposé ci-dessous.",
  router_example_usage_5:
    "Touchez l'emplacement proposé pour la passerelle résidentielle ci-dessous.",
  level_example_usage_1:
    "Rendez-vous au niveau 2 et touchez votre emplacement.",
  level_example_usage_2:
    "Rendez-vous à l'étage 2 et touchez votre emplacement.",
  mesh_pod_example_usage_1:
    "Estimation de la force du signal et du meilleur emplacement pour le module maillé.",
  mesh_pod_example_usage_2:
    "Estimation de la force du signal et du meilleur emplacement pour le point d'accès.",
  mesh_pod_example_usage_3:
    "Estimation de la force du signal et du meilleur emplacement pour le nœud maillé.",
  mesh_pod_example_usage_4:
    "Estimation de la force du signal et du meilleur emplacement pour le puck maillé.",
  mesh_pod_example_usage_5:
    "Estimation de la force du signal et du meilleur emplacement pour la balise.",
  mesh_pod_example_usage_6:
    "Estimation de la force du signal et du meilleur emplacement pour le prolongateur de portée.",
  wifi_example_usage_1: "Cartographie WiFi",
  wifi_example_usage_2: "Cartographie Wi-Fi",
  wifi_example_usage_3: "Cartographie Wifi",
  wifi_example_usage_4: "Cartographie WIFI",

  // Tenant Equipment Settings (Certify)
  router_options_1: "Options de Routeur",
  router_options_2: "Options de Modem",
  router_options_3: "Options de Passerelle",
  router_options_4: "Options de Hub",
  router_options_5: "Options de Passerelle Résidentielle",
  new_router_options_1: "Nouvelles Options de Routeur",
  new_router_options_2: "Nouvelles Options de Modem",
  new_router_options_3: "Nouvelles options de passerelle",
  new_router_options_4: "Nouvelles options de hub",
  new_router_options_5: "Nouvelles options de passerelle résidentielle",
  mesh_pod_options_1: "Options Pod Mesh",
  mesh_pod_options_2: "Options de point d'accès",
  mesh_pod_options_3: "Options de nœud Mesh",
  mesh_pod_options_4: "Options de Puck Mesh",
  mesh_pod_options_5: "Options de balise",
  mesh_pod_options_6: "Options d'extension de portée",
  new_mesh_pod_options_1: "Nouvelles options de Pod Mesh",
  new_mesh_pod_options_2: "Nouvelles Options de Point d'Accès",
  new_mesh_pod_options_3: "Nouvelles Options de Nœud Mesh",
  new_mesh_pod_options_4: "Nouvelles Options de Puck Mesh",
  new_mesh_pod_options_5: "Nouvelles Options de Balise",
  new_mesh_pod_options_6: "Nouvelles Options de Extenseur de Portée",
  missing_required_router_info_1: "Manque d'Information Requise sur le Routeur",
  missing_required_router_info_2: "Manque d'Information Requise sur le Modem",
  missing_required_router_info_3:
    "Manque d'Information Requise sur la Passerelle",
  missing_required_router_info_4:
    "Manque d'Information Requise sur le Concentrateur",
  missing_required_router_info_5:
    "Manque d'Information Requise sur la Passerelle Résidentielle",
  missing_required_mesh_pod_info_1:
    "Informations requises sur le Pod Mesh manquantes",
  missing_required_mesh_pod_info_2:
    "Informations requises sur le Point d'Accès manquantes",
  missing_required_mesh_pod_info_3:
    "Informations requises sur le Nœud Mesh manquantes",
  missing_required_mesh_pod_info_4:
    "Informations requises sur le Puck Mesh manquantes",
  missing_required_mesh_pod_info_5:
    "Informations requises sur la Balise manquantes",
  missing_required_mesh_pod_info_6:
    "Informations requises sur l'Extension de Portée manquantes",
  display_name: "Nom à afficher",
  description: "Description",
  range_in_unit_1: "Portée en pieds",
  range_in_unit_2: "Portée en mètres",
  area_in_unit_1: "Superficie en pieds carrés",
  area_in_unit_2: "Superficie en mètres carrés",
  default_active: "Activé par défaut",
  average_range: "Plage moyenne",
  certify_default: "Certifier par défaut",
  default: "Par défaut",
  active: "Active",
  one_option_must_be_default: "Une option doit être par défaut",
  set_as_default: "Définir comme défaut",
  default_option_must_be_active: "L'option par défaut doit être active",
  deactivate: "Désactiver",
  activate: "Activer",
  name_is_required: "Le nom est requis",

  // Client Name
  customer_1: "Customer",
  customer_2: "Abonné",
  // Wifi Name
  wifi_1: "WiFi",
  wifi_2: "Wi-Fi",
  wifi_3: "Wifi",
  wifi_4: "WIFI",

  // Unités
  units_1: "Pieds",
  units_2: "Mètres",

  // Misc
  confirm: "Confirmer",
  units: "Units",
  region: "Région",
  edit: "Edit",
  modified: "Modifié",
  create: "Create",
  created: "Créé",
  routethis_app: "RouteCette Appli",
  loading: "Chargement...",
  redirecting: "Redirection...",
  error: "Erreur",
  close: "Fermer",
  search: "Rechercher",
  all: "All",
  dismiss: "Ignorer",

  // Languages
  en: "Anglais (US)",
  "en-GB": "Anglais (GB)",
  da: "Danois",
  fi: "Finnois",
  fr: "Français",
  "fr-CA": "Français (Canada)",
  de: "Allemand",
  el: "Grec",
  it: "Italien",
  pt: "Portugais",
  "pt-BR": "Portugais (Brésil)",
  es: "Espagnol",
  "es-419": "Espagnol (Amérique latine)",
  sv: "Suédois",
};

export const en_errors = {
  // Client-side validation errors
  incorrect_email_or_password:
    "Courriel incorrect ou mot de passe, ou compte désactivé. Réessayez ou contactez un administrateur.",
  invalid_reset_code: "Code de réinitialisation invalide",
  password_minimum_requirements:
    "Votre mot de passe doit comprendre au moins 8 caractères, dont au moins une minuscule, une majuscule et un caractère numérique.",
  passwords_must_match: "Les mots de passe doivent correspondre.",
  must_include_new_password_email:
    "Doit inclure le nouveau mot de passe et le courriel de l'utilisateur",
  must_include_new_password_confirmation_code:
    "Doit inclure le nouveau mot de passe et le code de confirmation",
  cannot_send_reset_code_without_email:
    "Impossible d'envoyer le code de réinitialisation sans courriel",
  must_enter_old_password: "Doit entrer l'ancien mot de passe",
  must_enter_reset_code: "Doit entrer le code de réinitialisation",
  must_enter_new_password: "Doit entrer le nouveau mot de passe",
  passwords_cannot_begin_or_end_with_spaces:
    "Les mots de passe ne peuvent pas commencer ou finir par des espaces",

  // Server-side errors
  "Un utilisateur avec ce courriel existe déjà":
    "Un utilisateur avec ce courriel existe déjà",
  "Essayez un autre nom d'affichage": "Essayez un autre nom d'affichage",
  "Le mot de passe ne peut pas être un mot de passe déjà utilisé":
    "Le mot de passe ne peut pas être un mot de passe précédemment utilisé",
  "Code de réinitialisation invalide": "Code de réinitialisation invalide",
  "E-mail ou mot de passe incorrect, ou compte désactivé. Essayez à nouveau ou contactez un administrateur.":
    "E-mail ou mot de passe incorrect, ou compte désactivé. Essayez à nouveau ou contactez un administrateur.",
  "Code fourni invalide, veuillez demander à nouveau un code.":
    "Code fourni invalide, veuillez demander à nouveau un code.",
  "Le mot de passe ne peut pas commencer ou se terminer par des espaces":
    "Le mot de passe ne peut pas commencer ou se terminer par des espaces",
  "ExceptionLimiteDépassée - Limite d'essais dépassée, veuillez réessayer plus tard.":
    "LimitExceededException - Limite de tentatives dépassée, veuillez réessayer plus tard.",
  "L'utilisateur n'est pas autorisé": "L'utilisateur n'est pas autorisé",
  "Votre session a expiré. Connectez-vous à nouveau avec votre mot de passe temporaire.":
    "Votre session a expiré. Connectez-vous à nouveau avec votre mot de passe temporaire.",
  "Défaillance du service interne - Cognito indisponible":
    "Défaillance du service interne - Cognito indisponible",
  "Défaillance du service interne - Échec inconnu":
    "Défaillance du service interne - Échec inconnu",
  "Vous devez entrer le code de réinitialisation":
    "Doit entrer le Code de Réinitialisation ",

  // Change Password Challenges
  set_password_challenge:
    "Vous devez définir un nouveau mot de passe lors de votre première connexion pour des raisons de sécurité.",
  reset_password_challenge:
    "Nous avons envoyé un code de réinitialisation de mot de passe à [EMAIL]. Entrez ce code et un nouveau mot de passe.",
  set_new_password_challenge:
    "La politique de votre entreprise exige que votre mot de passe expire après un certain temps. Nous avons envoyé un code de réinitialisation de mot de passe à [EMAIL]. Entrez ce code et un nouveau mot de passe.",
  change_your_password_challenge:
    "Entrez votre mot de passe actuel et un nouveau mot de passe ci-dessous pour le changer.",
  change_password_challenge:
    "Entrez un nouveau mot de passe pour l'utilisateur",
};

export const en_countries = {
  AF: "Afghanistan",
  AX: "Îles Åland",
  AL: "Albanie",
  DZ: "Algérie",
  AS: "Samoa américaines",
  AD: "Andorre",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctique",
  AG: "Antigua-et-Barbuda",
  AR: "Argentine",
  AM: "Arménie",
  AW: "Aruba",
  AU: "Australie",
  AT: "Autriche",
  AZ: "Azerbaïdjan",
  BS: "Bahamas",
  BH: "Bahreïn",
  BD: "Bangladesh",
  BB: "Barbade",
  BY: "Biélorussie",
  BE: "Belgique",
  BZ: "Belize",
  BJ: "Bénin",
  BM: "Bermudes",
  BT: "Bhoutan",
  BO: "Bolivie (État plurinational de)",
  BQ: "Bonaire, Saint-Eustache et Saba",
  BA: "Bosnie-Herzégovine",
  BW: "Botswana",
  BV: "Île Bouvet",
  BR: "Brésil",
  IO: "Territoire britannique de l'océan Indien",
  BN: "Brunei Darussalam",
  BG: "Bulgarie",
  BF: "Burkina Faso",
  BI: "Burundi",
  CV: "Cabo Verde",
  KH: "Cambodge",
  CM: "Cameroun",
  CA: "Canada",
  KY: "Îles Caïmans",
  CF: "République centrafricaine",
  TD: "Tchad",
  CL: "Chili",
  CN: "Chine",
  CX: "Île Christmas",
  CC: "Îles Cocos (Keeling)",
  CO: "Colombie",
  KM: "Comores",
  CG: "Congo",
  CD: "Congo, République démocratique du",
  CK: "Îles Cook",
  CR: "Costa Rica",
  CI: "Côte d'Ivoire",
  HR: "Croatie",
  CU: "Cuba",
  CW: "Curaçao",
  CY: "Chypre",
  CZ: "Tchéquie",
  DK: "Danemark",
  DJ: "Djibouti",
  DM: "Dominique",
  DO: "République Dominicaine",
  EC: "Équateur",
  EG: "Égypte",
  SV: "El Salvador",
  GQ: "Guinée Équatoriale",
  ER: "Érythrée",
  EE: "Estonie",
  SZ: "Eswatini",
  ET: "Éthiopie",
  FK: "Îles Falkland (Malouines)",
  FO: "Îles Féroé",
  FJ: "Fidji",
  FI: "Finlande",
  FR: "France",
  GF: "Guyane française",
  PF: "Polynésie française",
  TF: "Terres australes françaises",
  GA: "Gabon",
  GM: "Gambie",
  GE: "Géorgie",
  DE: "Allemagne",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grèce",
  GL: "Groenland",
  GD: "Grenade",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernesey",
  GN: "Guinée",
  GW: "Guinée-Bissau",
  GY: "Guyane",
  HT: "Haïti",
  HM: "Îles Heard et McDonald",
  VA: "Saint-Siège",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hongrie",
  IS: "Islande",
  IN: "Inde",
  ID: "Indonésie",
  IR: "Iran (République islamique d')",
  IQ: "Irak",
  IE: "Irlande",
  IM: "Île de Man",
  IL: "Israël",
  IT: "Italie",
  JM: "Jamaïque",
  JP: "Japon",
  JE: "Jersey",
  JO: "Jordanie",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Corée (République populaire démocratique de)",
  KR: "Corée, République de",
  KW: "Koweït",
  KG: "Kirghizistan",
  LA: "République démocratique populaire lao",
  LV: "Lettonie",
  LB: "Liban",
  LS: "Lesotho",
  LR: "Libéria",
  LY: "Libye",
  LI: "Liechtenstein",
  LT: "Lituanie",
  LU: "Luxembourg",
  MO: "Macao",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaisie",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malte",
  MH: "Îles Marshall",
  MQ: "Martinique",
  MR: "Mauritanie",
  MU: "Maurice",
  YT: "Mayotte",
  MX: "Mexique",
  FM: "Micronésie (États fédérés de)",
  MD: "Moldavie, République de",
  MC: "Monaco",
  MN: "Mongolie",
  ME: "Monténégro",
  MS: "Montserrat",
  MA: "Maroc",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibie",
  NR: "Nauru",
  NP: "Népal",
  NL: "Pays-Bas",
  NC: "Nouvelle-Calédonie",
  NZ: "Nouvelle-Zélande",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Île Norfolk",
  MK: "Macédoine du Nord",
  MP: "Îles Mariannes du Nord",
  NO: "Norvège",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palaos",
  PS: "Palestine, État de ",
  PA: "Panama",
  PG: "Papouasie-Nouvelle-Guinée",
  PY: "Paraguay",
  PE: "Pérou",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Pologne",
  PT: "Portugal",
  PR: "Porto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Roumanie",
  RU: "Fédération Russe",
  RW: "Rwanda",
  BL: "Saint-Barthélemy",
  SH: "Sainte-Hélène, Ascension et Tristan da Cunha",
  KN: "Saint-Christophe-et-Niévès",
  LC: "Sainte-Lucie",
  MF: "Saint-Martin (partie française)",
  PM: "Saint-Pierre-et-Miquelon",
  VC: "Saint-Vincent-et-les-Grenadines",
  WS: "Samoa",
  SM: "Saint-Marin",
  ST: "Sao Tomé et Principe",
  SA: "Arabie Saoudite",
  SN: "Sénégal",
  RS: "Serbie",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapour",
  SX: "Saint-Martin (partie néerlandaise)",
  SK: "Slovaquie",
  SI: "Slovénie",
  SB: "Îles Salomon",
  SO: "Somalie",
  ZA: "Afrique du Sud",
  GS: "Géorgie du Sud et les îles Sandwich du Sud",
  SS: "Soudan du Sud",
  ES: "Espagne",
  LK: "Sri Lanka",
  SD: "Soudan",
  SR: "Suriname",
  SJ: "Svalbard et Jan Mayen",
  SE: "Suède",
  CH: "Suisse",
  SY: "République arabe syrienne",
  TW: "Taiwan, province de Chine",
  TJ: "Tadjikistan",
  TZ: "Tanzanie, République-Unie de",
  TH: "Thaïlande",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinité-et-Tobago",
  TN: "Tunisie",
  TR: "Turquie",
  TM: "Turkménistan",
  TC: "Îles Turques-et-Caïques",
  TV: "Tuvalu",
  UG: "Ouganda",
  UA: "Ukraine",
  AE: "Émirats Arabes Unis",
  GB: "Royaume-Uni de Grande-Bretagne et d'Irlande du Nord",
  US: "États-Unis d'Amérique",
  UM: "Îles mineures éloignées des États-Unis",
  UY: "Uruguay",
  UZ: "Ouzbékistan",
  VU: "Vanuatu",
  VE: "Venezuela (République bolivarienne du)",
  VN: "Viet Nam",
  VG: "Îles Vierges (britanniques)",
  VI: "Îles Vierges (américaines)",
  WF: "Wallis et Futuna",
  EH: "Sahara occidental",
  YE: "Yémen",
  ZM: "Zambie",
  ZW: "Zimbabwe",
};
